export const siteSettings = {
  name: "First Prudential Market",
  link: "https://firstprudentialmarket.org",
  email: "support@firstprudentialmarket.org",
  appLink: "https://app.firstprudentialmarket.org",
};
